import { PopperProps } from "@mui/base";
import { ClickAwayListener, Popper } from "@mui/material";
import { memo, useState } from "react";
import { RedoButton } from "../arbiter-components/buttons/redo-button";
import { RedoTextInput } from "../arbiter-components/input/redo-text-input";
import { Flex } from "../flex";

export const QuillLinkPopup = memo(function QuillLinkPopup({
  anchorEl,
  initialUrl = "",
  onSubmit,
  onRemove,
  onClose,
}: {
  anchorEl: PopperProps["anchorEl"];
  /** Existing link URL, so an already-linked selection opens pre-filled for editing. */
  initialUrl?: string;
  onSubmit(link: string): void;
  /** Remove the link entirely. Shown only when editing an existing link. */
  onRemove?(): void;
  onClose(): void;
}) {
  const [url, setUrl] = useState<string>(initialUrl);
  const keyUpHandlers = new Map<string, () => void>([
    ["Enter", () => onSubmit(url)],
    ["Escape", onClose],
  ]);
  return (
    <ClickAwayListener
      mouseEvent="onMouseDown"
      onClickAway={onClose}
      touchEvent="onTouchStart"
    >
      <Popper anchorEl={anchorEl} open placement="top">
        <Flex pb="md">
          <Flex
            align="center"
            bgColor="primary"
            borderColor="primary"
            borderRadius="lg"
            borderStyle="solid"
            borderWidth="1px"
            gap="xs"
            px="md"
            py="xs"
          >
            <Flex
              gap="xs"
              onKeyUp={(e) => {
                const handler = keyUpHandlers.get(e.key);
                if (handler) {
                  e.stopPropagation();
                  handler();
                }
              }}
            >
              <RedoTextInput
                placeholder="Paste or type a link"
                setValue={setUrl}
                value={url}
              />
            </Flex>
            {onRemove && initialUrl ? (
              <RedoButton
                hierarchy="tertiary"
                onClick={onRemove}
                size="sm"
                text="Remove"
              />
            ) : null}
            <RedoButton
              hierarchy="tertiary"
              onClick={() => onSubmit(url)}
              size="sm"
              text="Save"
            />
          </Flex>
        </Flex>
      </Popper>
    </ClickAwayListener>
  );
});
